<template>
  <div
    class="module-wrap module-detail"
    :knowlegeDetailData="knowlegeDetailData"
  >
    <h2 v-html="moduleTitle"></h2>
    <div class="my-chart-wrap">
      <p class="zwl-text"> 平均掌握程度</p>
      <p class="zwl-value">{{ zwlRate }}</p>
      <div
        class=""
        id="myChart"
        :style="{ width: '740px', height: '300px' }"
      ></div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'ModuleKnowlegeDetail',
  props: ['moduleTitle', 'knowlegeDetailData'],
  data() {
    return {
      actual_master_num: 0,
      actual_weak_num: 0,
      estimate_weak_num: 0,
      estimate_master_num: 0,
      zwlRate: '',
    };
  },
  created() {},
  watch: {
    knowlegeDetailData(val) {
      this.getData();
      // console.log( val )  监听动态改变数据
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      const res = await this.knowlegeDetailData;
      if (res) {
        // this.actual_master_num = res.actual_master_num //实测掌握
        // this.actual_weak_num = res.actual_weak_num // 实测未掌握
        // this.estimate_weak_num = res.estimate_weak_num //推测未掌握
        // this.estimate_master_num = res.estimate_master_num //推测掌握
        const tczw = res.estimate_master_num || 0;
        const tcwzw = res.estimate_weak_num || 0;
        const sczw = res.actual_master_num || 0;
        const scwzw = res.actual_weak_num || 0;
        const zwl = res.mastery_rate || 0;
        const resdata = {
          tczw,
          tcwzw,
          sczw,
          scwzw,
          zwl,
        };
        this.zwlRate = `${Math.round(zwl * 100)}%`;
        // this.renderChart(document.getElementById('myChart'),tczw, scwzw,tcwzw,sczw,zwl)
        this.renderChart(document.getElementById('myChart'), resdata);
      }
    },
    renderChart(id, res) {
      const myChart = echarts.init(id);
      // const option = {
      //   tooltip: {
      //     trigger: 'item',
      //     // formatter: "{a} <br/>{b}: {d}%"
      //     formatter: '{a} <br/>{b}',
      //   },
      //   legend: {
      //     orient: 'horizontal',
      //     selectedMode: false,
      //     // data: ['推测掌握','实测未掌握','推测未掌握','实测掌握'],
      //     data: [
      //       {
      //         name: `实测掌握${res.sczw}`,
      //         icon: 'circle',
      //       },
      //       {
      //         name: `推测掌握${res.tczw}`,
      //         icon: 'circle',
      //       },
      //       {
      //         name: `实测未掌握${res.scwzw}`,
      //         icon: 'circle',
      //       },
      //       {
      //         name: `推测未掌握${res.tcwzw}`,
      //         icon: 'circle',
      //       },
      //     ],
      //     align: 'left',
      //   },
      //   series: [
      //     {
      //       name: '',
      //       type: 'pie',
      //       selectedMode: 'single',
      //       radius: ['0%', '30%'],
      //       center: ['50%', '50%'],
      //       label: {
      //         normal: {
      //           show: false,
      //           color: '#333',
      //           position: 'center',
      //           textStyle: {
      //             fontSize: 24,
      //             lineHeight: 120,
      //           },
      //         },
      //       },
      //       labelLine: {
      //         normal: {
      //           show: false,
      //         },
      //       },
      //       data: [
      //         {
      //           value: res.zwl,
      //           name: `${Math.round(res.zwl * 100)}%`,
      //         },
      //       ],
      //       itemStyle: {
      //         normal: {
      //           shadowBlur: 10,
      //           shadowColor: 'rgba(0, 0, 0, 0.3)',
      //           color(params) {
      //             // 自定义颜色
      //             const colorList = ['#fff'];
      //             return colorList[params.dataIndex];
      //           },
      //         },
      //       },
      //     },
      //     {
      //       name: '',
      //       type: 'pie',
      //       radius: ['40%', '55%'],
      //       center: ['50%', '50%'],
      //       avoidLabelOverlap: true,
      //       silent: false,
      //       labelLine: {
      //         show: true,
      //       },
            // data: [
            //   {
            //     value: res.sczw,
            //     name: `实测掌握${res.sczw}`,

            //     label: {
            //       show: (function () {
            //         if (res.sczw == 0) {
            //           return false;
            //         }
            //       }()),
            //     },
            //     labelLine: {
            //       show: (function () {
            //         if (res.sczw == 0) {
            //           return false;
            //         }
            //       }()),
            //     },
            //   },
            //   {
            //     value: res.tczw,
            //     name: `推测掌握${res.tczw}`,

            //     label: {
            //       show: (function () {
            //         if (res.tczw == 0) {
            //           return false;
            //         }
            //       }()),
            //     },
            //     labelLine: {
            //       show: (function () {
            //         if (res.tczw == 0) {
            //           return false;
            //         }
            //       }()),
            //     },
            //   },
            //   {
            //     value: res.scwzw,
            //     name: `实测未掌握${res.scwzw}`,

            //     label: {
            //       show: (function () {
            //         if (res.scwzw == 0) {
            //           return false;
            //         }
            //       }()),
            //     },
            //     labelLine: {
            //       show: (function () {
            //         if (res.scwzw == 0) {
            //           return false;
            //         }
            //       }()),
            //     },
            //   },
            //   {
            //     value: res.tcwzw,
            //     name: `推测未掌握${res.tcwzw}`,

            //     label: {
            //       show: (function () {
            //         if (res.tcwzw == 0) {
            //           return false;
            //         }
            //       }()),
            //     },
            //     labelLine: {
            //       show: (function () {
            //         if (res.tcwzw == 0) {
            //           return false;
            //         }
            //       }()),
            //     },
            //   },
            // ],
      //       itemStyle: {
      //         emphasis: {
      //           shadowBlur: 10,
      //           shadowOffsetX: 0,
      //           shadowColor: 'rgba(0, 0, 0, 0.5)',
      //         },
      //         normal: {
      //           borderWidth: 3,
      //           borderColor: '#fff',
      //           color(params) {
      //             // 自定义颜色
      //             const colorList = [
      //               '#4E74FF',
      //               '#00B1FF',
      //               '#FF6E82',
      //               '#FF9A42',
      //             ];
      //             return colorList[params.dataIndex];
      //           },
      //         },
      //       },
      //     },
      //   ],
      // };
    const option = {

    title: {
        left: 'center'
    },
    tooltip: {
        trigger: 'item'
    },
    legend: {
        orient: 'horizontal',
        left: 'center',
        width:'100%',
        itemWidth:20,
        textStyle: {
            fontSize: 10,
            lineHeight: 40,
        },
        icon: "circle"
    },
    series: [
        {
            name: '知识点掌握情况',
            type: 'pie',
            radius: ['35%', '55%'],
            center: ['50%', '50%'],
            label: {
                // formatter: '{a|{a}}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ',
                // formatter: '{b}\n{hr|}\n{c}\t\t{d}%',
                formatter:function(data){
                   return data.name+'\n' +''+ data.value +'个';
                },
                // backgroundColor: '#eee',
                // borderColor: '#aaa',
                // borderWidth: 1,
                // borderRadius: 4,
                // shadowBlur:3,
                // shadowOffsetX: 2,
                // shadowOffsetY: 2,
                // shadowColor: '#999',
                // padding: [0, 7],
                rich: {
                    a: {
                      color: '#999',
                      lineHeight: 22,
                      align: 'center'
                    },
                    hr: {
                        // borderColor: '#aaa',
                        width: '100%',
                        borderWidth: 0.5,
                        height: 5,
                    },
                    b: {
                        fontSize: 16,
                        lineHeight: 33
                    },
                    per: {
                        color: '#eee',
                        // backgroundColor: '#334455',
                        padding: [2, 4],
                        borderRadius: 2
                    },
                    d:{
                    }
                }
            },

               data: [
              {
                value: res.sczw,
                name: '实测掌握',

                label: {
                  show: (function () {
                    if (res.sczw == 0) {
                      return false;
                    }
                  }()),
                },
                labelLine: {
                  show: (function () {
                    if (res.sczw == 0) {
                      return false;
                    }
                  }()),
                },
              },
              {
                value: res.tczw,
                name: '推测掌握',

                label: {
                  show: (function () {
                    if (res.tczw == 0) {
                      return false;
                    }
                  }()),
                },
                labelLine: {
                  show: (function () {
                    if (res.tczw == 0) {
                      return false;
                    }
                  }()),
                },
              },
              {
                value: res.scwzw,
                name: '实测未掌握',

                label: {
                  show: (function () {
                    if (res.scwzw == 0) {
                      return false;
                    }
                  }()),
                },
                labelLine: {
                  show: (function () {
                    if (res.scwzw == 0) {
                      return false;
                    }
                  }()),
                },
              },
              {
                value: res.tcwzw,
                name: '推测未掌握',

                label: {
                  show: (function () {
                    if (res.tcwzw == 0) {
                      return false;
                    }
                  }()),
                },
                labelLine: {
                  show: (function () {
                    if (res.tcwzw == 0) {
                      return false;
                    }
                  }()),
                },
              },
            ],
            emphasis: {
                itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
            },
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
              normal: {
                borderWidth: 3,
                borderColor: '#fff',
                color(params) {
                  // 自定义颜色
                  const colorList = [
                    '#00B853','#0089FF','#F55B5D', '#F78A49', '#F3C100', '#3DC7EE','#4E74FF'
                  ];
                  return colorList[params.dataIndex];
                },
              },
            },
        }
    ]
      };
      if (option && typeof option === 'object') {
        myChart.setOption(option, true);
      }
    },
  },
};
</script>

<style scoped>
body {
  color: #333;
}
.my-chart-wrap {
  position: relative;
}
.zwl-text {
  font-size: 14px;
  top: 42%;
  position: absolute;
  left: 330px;
  z-index: 9;
}
.zwl-value {
  top: 48%;
  position: absolute;
  left: 350px;
  z-index: 9;
  color: #333;
  font-size: 24px;
}
h2 {
  width: 358px;
  height: 40px;
  margin: 58px auto 32px auto;
  font-size: 20px;
  line-height: 40px;
  text-align: center;
  background: url("~@/assets/img/sub_headbg.png") no-repeat;
  background-size: cover;
}
</style>
